export const priceShow = (price?: string) => {
  if (price && price?.length) {
    return new Intl.NumberFormat('ru-RU').format(parseFloat(price))
  }

  return ''
}
